import React from 'react';
import {
  Box,
  Flex,
  Text,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  IconButton,
  Image,
  HStack,
} from '@chakra-ui/react';
import { SignOut, User, CaretDown, List } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/logo_dark_blue.png';

interface ClienteData {
  id: number;
  guid: string;
  nome: string;
  email: string;
}

interface SecaoClienteHeaderProps {
  onOpenSidebar?: () => void;
  isMobile?: boolean;
}

const SecaoClienteHeader = ({ onOpenSidebar, isMobile }: SecaoClienteHeaderProps) => {
  const navigate = useNavigate();

  // Pegar dados do cliente do localStorage
  const clienteDataStr = localStorage.getItem('cliente_data');
  const clienteData: ClienteData | null = clienteDataStr ? JSON.parse(clienteDataStr) : null;

  const handleLogout = () => {
    localStorage.removeItem('cliente_access_token');
    localStorage.removeItem('cliente_refresh_token');
    localStorage.removeItem('cliente_data');
    navigate('/secao-cliente/login');
  };

  // Pegar iniciais do nome
  const getInitials = (nome: string) => {
    const parts = nome.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return nome.slice(0, 2).toUpperCase();
  };

  // Pegar primeiro nome
  const getFirstName = (nome: string) => {
    return nome.split(' ')[0];
  };

  return (
    <Box
      position="fixed"
      top={0}
      left={{ base: 0, lg: '280px' }}
      right={0}
      h="70px"
      bg="white"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
      zIndex={100}
      boxShadow="sm"
      transition="left 0.3s ease"
    >
      <Flex h="100%" align="center" justify="space-between" px={{ base: 4, md: 6 }}>
        {/* Left side - Menu button (mobile) + Logo (mobile) */}
        <HStack spacing={3}>
          {isMobile && (
            <IconButton
              aria-label="Abrir menu"
              icon={<List size={24} weight="bold" />}
              variant="ghost"
              color="gray.600"
              onClick={onOpenSidebar}
              _hover={{ bg: 'gray.100' }}
            />
          )}
          {isMobile && (
            <Flex align="center" gap={2}>
              {(() => {
                try {
                  const data = JSON.parse(localStorage.getItem('cliente_data') || '{}');
                  if (data.empresa_logo_url) {
                    return (
                      <Image
                        src={data.empresa_logo_url}
                        alt="Logo empresa"
                        h="28px"
                        maxW="60px"
                        objectFit="contain"
                      />
                    );
                  }
                } catch {
                  /* ignore */
                }
                return null;
              })()}
              <Image src={logo} alt="Logo" h="32px" objectFit="contain" />
            </Flex>
          )}
        </HStack>

        {/* Right side - User Menu */}
        <Menu>
          <MenuButton as={Box} cursor="pointer" _hover={{ opacity: 0.8 }} transition="opacity 0.2s">
            <Flex align="center" gap={3}>
              <Avatar
                size="sm"
                name={clienteData?.nome || 'Cliente'}
                bg="blue.500"
                color="white"
                fontSize="xs"
              >
                {clienteData?.nome ? getInitials(clienteData.nome) : 'CL'}
              </Avatar>
              <Box textAlign="left" display={{ base: 'none', sm: 'block' }}>
                <Text fontSize="sm" fontWeight="600" color="gray.700" lineHeight="1.2">
                  {clienteData?.nome ? getFirstName(clienteData.nome) : 'Cliente'}
                </Text>
                <Text fontSize="xs" color="gray.500" lineHeight="1.2">
                  Área do Cliente
                </Text>
              </Box>
              <Icon
                as={CaretDown}
                boxSize={4}
                color="gray.400"
                display={{ base: 'none', sm: 'block' }}
              />
            </Flex>
          </MenuButton>
          <MenuList shadow="lg" borderRadius="xl" py={2}>
            <MenuItem
              icon={<User size={18} />}
              fontSize="sm"
              py={3}
              _hover={{ bg: 'gray.50' }}
              onClick={() => navigate('/secao-cliente/perfil')}
            >
              Meu Perfil
            </MenuItem>
            <MenuItem
              icon={<SignOut size={18} />}
              fontSize="sm"
              py={3}
              color="red.500"
              _hover={{ bg: 'red.50' }}
              onClick={handleLogout}
            >
              Sair
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Box>
  );
};

export default SecaoClienteHeader;
